/* Zubehoer-Akkordeon der Produktseite (snippets/pdp-accessories.liquid).
   Daten: Shopify Product Recommendations API, intent=complementary (Search & Discovery).
   Warenkorb: /cart/add.js + Theme-Ereignis "ajax:addToCart" (Mini-Cart) + vorhandener Drawer-Trigger. */
(function () {
  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
      return Shopify.formatMoney(cents, theme.moneyFormat) + ' EUR';
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',') + ' EUR';
  }
  function net(cents) { return Math.round(cents * 100 / 119); }

  function init(acc) {
    if (acc.hasAttribute('data-acc-ready')) return;
    acc.setAttribute('data-acc-ready', '');
    var toggle = acc.querySelector('[data-acc-toggle]');
    var itemsBox = acc.querySelector('[data-acc-items]');
    var msg = acc.querySelector('[data-acc-msg]');

    // Eine Anfrage pro Seitenaufruf; der Balken erscheint nur, wenn Zubehoer zugeordnet ist.
    fetch(acc.getAttribute('data-url'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('[data-acc-list]');
        if (!list || !list.querySelector('[data-acc-item]')) return;
        itemsBox.appendChild(list);
        acc.hidden = false;
      })
      .catch(function () {});

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      acc.classList.toggle('is-open', open);
    });

    // Eigene Events nicht an Hauptformular/Theme-Handler weiterreichen
    ['change', 'input'].forEach(function (t) {
      acc.addEventListener(t, function (e) {
        var sel = e.target.closest('[data-acc-select]');
        if (sel && t === 'change') updateItem(sel);
        e.stopPropagation();
      });
    });

    acc.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-acc-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      add(btn);
    });

    function updateItem(sel) {
      var item = sel.closest('[data-acc-item]');
      var data = [];
      try { data = JSON.parse(item.querySelector('[data-acc-json]').textContent); } catch (err) {}
      var v = data.filter(function (x) { return String(x.id) === sel.value; })[0];
      if (!v) return;
      var request = v.p > 100000;
      var btn = item.querySelector('[data-acc-add]');
      btn.setAttribute('data-vid', v.id);
      btn.disabled = !v.a || request;
      var netEl = item.querySelector('[data-acc-net]');
      netEl.textContent = money(net(v.p));
      netEl.classList.toggle('is-sale', v.c > v.p);
      var cmp = item.querySelector('[data-acc-cmp]');
      if (v.c > v.p) { cmp.textContent = money(net(v.c)); cmp.hidden = false; } else { cmp.hidden = true; }
      item.querySelector('[data-acc-gross]').textContent = money(v.p) + ' inkl. MwSt.';
      item.querySelector('[data-acc-stock]').innerHTML = request
        ? '<span class="is-request">Verfügbar – auf Anfrage</span>'
        : (v.a ? '<span class="is-in">Sofort lieferbar</span>' : '<span class="is-out">Ausverkauft – Im Zulauf</span>');
      var ids = item.querySelector('[data-acc-ids]');
      ids.textContent = '';
      [['Art.-Nr.: ', v.s], ['PZN: ', v.z], ['EAN: ', v.e]].forEach(function (p) {
        if (!p[1]) return;
        var s = document.createElement('span');
        s.textContent = p[0] + p[1];
        ids.appendChild(s);
      });
    }

    function add(btn) {
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.disabled = true;
      msg.textContent = '';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-vid'), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) {
            msg.textContent = (res.j && res.j.description) || 'Der Artikel konnte nicht hinzugefügt werden.';
            return;
          }
          document.body.dispatchEvent(new CustomEvent('ajax:addToCart', { detail: { response: res.j } }));
          if (!document.documentElement.classList.contains('pside_opened')) {
            var opener = document.querySelector('.push_side[data-id="#js_cart_popup"]');
            if (opener) opener.click();
          }
        })
        .catch(function () { msg.textContent = 'Der Artikel konnte nicht hinzugefügt werden.'; })
        .finally(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
    }
  }

  function start() {
    var run = function () { document.querySelectorAll('[data-pdp-acc]').forEach(init); };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2000 });
    else setTimeout(run, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
